import { TransactionReceipt } from "@ethersproject/abstract-provider";
import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { BigNumber } from "ethers";
import { contractBaseQuery } from "./contract.base-query";
import { EApiSourceName, TContractAddress, TERC20Token } from "./types";

type TRecipient = string;
type TSpender = string;
type TOwner = string;
type TAmount = BigNumber;

const tokenContractApi = createApi({
  reducerPath: "tokenContractApi",
  baseQuery: contractBaseQuery,
  endpoints: (builder) => ({
    balanceOf: builder.query({
      query: ([contractAddress, account]) => ({
        contractAddress,
        method: "balanceOf",
        contractName: EApiSourceName.TOKEN,
        callData: [account],
      }),
    }),
    decimals: builder.query<number, [TContractAddress]>({
      query: ([contractAddress]) => ({
        contractAddress,
        method: "decimals",
        contractName: EApiSourceName.TOKEN,
      }),
    }),
    symbol: builder.query<string, [TContractAddress]>({
      query: ([contractAddress]) => ({
        contractAddress,
        method: "symbol",
        contractName: EApiSourceName.TOKEN,
      }),
    }),
    getTokensData: builder.query<TERC20Token[], [TContractAddress[]]>({
      queryFn: async ([contractAddresses], unusedApi, unusedExtra, contractBaseQuery) => {
        const decimalsPromises = contractAddresses.map((el) =>
          contractBaseQuery({
            contractAddress: el,
            contractName: EApiSourceName.TOKEN,
            method: "decimals",
          }),
        );

        const symbolPromises = contractAddresses.map((el) =>
          contractBaseQuery({
            contractAddress: el,
            contractName: EApiSourceName.TOKEN,
            method: "symbol",
          }),
        );

        const decimals = await Promise.all(decimalsPromises);
        const symbols = await Promise.all(symbolPromises);
        console.log("decimals", decimals);
        return {
          data: contractAddresses.map((el, i) => ({
            address: el,
            decimals: decimals[i].data as unknown as number,
            symbol: symbols[i].data as unknown as string,
          })),
        };
      },
    }),
    allowance: builder.query<BigNumber, [TContractAddress, TOwner, TSpender]>({
      query: ([contractAddress, ...args]) => ({
        contractAddress,
        method: "allowance",
        contractName: EApiSourceName.TOKEN,
        callData: args,
      }),
    }),
    approve: builder.mutation<TransactionReceipt, [TContractAddress, TRecipient, TAmount]>({
      query: ([contractAddress, ...args]) => ({
        contractAddress,
        method: "approve",
        contractName: EApiSourceName.TOKEN,
        callData: args,
      }),
    }),
    transfer: builder.mutation<TransactionReceipt, [TContractAddress, TRecipient, TAmount]>({
      query: ([contractAddress, ...args]) => ({
        contractAddress: contractAddress,
        method: "transfer",
        contractName: EApiSourceName.TOKEN,
        callData: args,
      }),
    }),
  }),
});

export const {
  useTransferMutation,
  useBalanceOfQuery,
  useApproveMutation,
  useAllowanceQuery,
  useDecimalsQuery,
  useSymbolQuery,
  useGetTokensDataQuery,
} = tokenContractApi;

export default tokenContractApi;
